import { Component, Input } from '@angular/core';

@Component({
	selector: 'my-account-components-error-state',
	templateUrl: './error-state.component.html'
})
export class ErrorStateComponent {
	@Input() icon = 'alert-error-filled';
	@Input() title = 'Something went wrong.';
	@Input() description = 'Refresh the page or try again later.';
}
